import { useEffect, useState } from 'react';
import bureaucrat from './util/Bureaucrat';
import { initializeBureaucratLogReporter } from './util/reporters/bureaucratReporter';
import { getConsoleLogger, getLogger } from './util/logger';
import { initializeConfig, logConfig, verifyConfig } from './util/config';

export function useInitializeApp() {
  const [sessionInitialized, setSessionInitialized] = useState(false);

  useEffect(() => {
    if (!sessionInitialized) {
      // call the tenant-profile api to setup the http session
      // then proceed to initialize the logger and config
      bureaucrat.getTenantProfile().then(() => {
        // to avoid circular dependencies,the following configurations
        // need to be done outside of their respective modules
        initializeBureaucratLogReporter(
          bureaucrat,
          getConsoleLogger('BureaucratLogTransport'),
        );
        initializeConfig(getLogger('config'), getConsoleLogger('config'));

        verifyConfig();
        logConfig();
        setSessionInitialized(true);
      });
    }
  }, [sessionInitialized]);

  return sessionInitialized;
}
